// plugins/enable-devtools.client.ts
export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()

  // Só ativa se estivermos no cliente E a flag de debug estiver true
  if (import.meta.client && config.public.isProdDebug) {

    // Cast para 'any' para evitar erro de TS
    (nuxtApp.vueApp.config as any).devtools = true;

    console.warn('⚠️ ALERTA: Vue DevTools ativado em produção! (NUXT_ENABLE_PROD_DEVTOOLS=true)');
  }
});